import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import { PhoneLinesList } from 'features/PhoneLines/PhoneLinesList'

export interface IPhoneLinesProps {
  location: {
    query: {
      ban?: string
      type?: string
      search?: string
      page?: string
    }
  }
}

export class PhoneLines extends React.Component<IPhoneLinesProps> {
  render() {
    const { location } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Phone Lines">
        <PageHeader>
          <Crumbs title="Phone Lines" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <PhoneLinesList
            page={parseInt(location.query.page || '1', 10)}
            ban={location.query.ban}
            type={location.query.type}
            search={location.query.search}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/PhoneLines/PhoneLines.tsx